/* Sleepsaurus — interacciones de las secciones mt-* */
(function () {
  function reveal(root) {
    const els = (root || document).querySelectorAll('.mt-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach((e) => io.observe(e));
    if (window.__mtSweep) return;
    let raf = 0;
    const sweep = () => { raf = 0; document.querySelectorAll('.mt-reveal:not(.is-in)').forEach((e) => { if (e.getBoundingClientRect().top < innerHeight) e.classList.add('is-in'); }); };
    window.__mtSweep = () => { if (!raf) raf = requestAnimationFrame(sweep); };
    addEventListener('scroll', window.__mtSweep, { passive: true });
    addEventListener('resize', window.__mtSweep);
    addEventListener('load', window.__mtSweep);
    setTimeout(window.__mtSweep, 1500);
  }

  // Selector de colores de la portada
  function colors(root) {
    (root || document).querySelectorAll('[data-mt-colors]').forEach((sec) => {
      if (sec.dataset.ready) return; sec.dataset.ready = 1;
      const btns = sec.querySelectorAll('[data-mt-swatch]');
      const imgs = sec.querySelectorAll('[data-mt-color-img]');
      const name = sec.querySelector('[data-mt-color-name]');
      const link = sec.querySelector('[data-mt-color-link]');
      btns.forEach((b) => b.addEventListener('click', () => {
        const i = b.dataset.mtSwatch;
        btns.forEach((x) => x.setAttribute('aria-pressed', x === b));
        imgs.forEach((im) => im.classList.toggle('is-active', im.dataset.mtColorImg === i));
        if (name) name.textContent = b.dataset.name;
        if (link && b.dataset.url) link.href = b.dataset.url;
        sec.style.setProperty('--mt-glow', b.dataset.color);
      }));
    });
  }

  // Acordeones animados
  function accordions(root) {
    (root || document).querySelectorAll('.mt-acc details').forEach((d) => {
      if (d.dataset.ready) return; d.dataset.ready = 1;
      const s = d.querySelector('summary'); const body = d.querySelector('.mt-acc__body');
      s.addEventListener('click', (e) => {
        e.preventDefault();
        if (d.open) {
          body.style.height = body.scrollHeight + 'px';
          requestAnimationFrame(() => { body.style.height = '0px'; });
          d.classList.remove('is-open');
          setTimeout(() => { d.open = false; }, 350);
        } else {
          d.open = true; d.classList.add('is-open');
          body.style.height = '0px';
          requestAnimationFrame(() => { body.style.height = body.scrollHeight + 'px'; });
          setTimeout(() => { body.style.height = 'auto'; }, 360);
        }
      });
    });
  }

  function init(root) { reveal(root); colors(root); accordions(root); }
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
